export default {
  auth: {
    logout: 'Cerrar sesión',
  },
  form: {
    create: 'Crear',
    submit: 'Enviar',
    submitting: 'Enviando...',
    continue: 'Continuar',
    cancel: 'Cancelar',
  },
  modules: {
    onboarding: {
      title: 'Plantillas de correo',
      emailTemplates: {
        title: 'Plantillas de correo',
        scopeNote: 'Por ahora se cubren los correos de onboarding.',
        description:
          'Edita los correos de onboarding y del ciclo de vida de prueba a nivel de sistema. Los cambios se aplican a todas las organizaciones; restablecer devuelve la plantilla a su valor predeterminado.',
        empty: 'No hay plantillas de correo disponibles.',
        language: 'Idioma',
        languages: {
          'en-US': 'Inglés (EE. UU.)',
          'es-ES': 'Español (España)',
        },
        keysLabel: 'Plantillas de correo',
        keys: {
          ACCOUNT_CREATED: 'Cuenta creada',
          NO_LOGIN_24H: 'Sin inicio de sesión tras 24 h',
          POST_FIRST_LOGIN: 'Tras el primer inicio de sesión',
          TRIAL_EXPIRING: 'Prueba por vencer',
          ORG_DISABLED: 'Organización deshabilitada',
        },
        customized: 'Personalizada',
        default: 'Predeterminada',
        variables: 'Variables',
        variablesHint: 'Haz clic en una variable para insertarla en el campo activo.',
        subject: 'Asunto',
        html: 'Cuerpo HTML',
        text: 'Cuerpo de texto plano',
        textBodyHint:
          'Versión en texto plano que se envía junto al HTML para clientes que no muestran HTML y para mejorar la entregabilidad. Edítala solo si necesitas que difiera del HTML.',
        actions: {
          save: 'Guardar cambios',
          reset: 'Restablecer predeterminada',
        },
        saveSuccess: 'Plantilla guardada',
        saveError: 'No se pudo guardar la plantilla',
        resetSuccess: 'Plantilla restablecida al valor predeterminado',
        preview: {
          title: 'Vista previa',
          subjectLabel: 'Asunto:',
          htmlTab: 'HTML',
          textTab: 'Texto',
          staleHint:
            'Mostrando la última vista previa válida: el borrador actual tiene un error de renderizado.',
          error: 'No se pudo renderizar la plantilla.',
          empty: 'No hay vista previa disponible.',
        },
        error: {
          subjectRequired: 'El asunto es obligatorio.',
          htmlRequired: 'El cuerpo HTML es obligatorio.',
          textRequired: 'El cuerpo de texto plano es obligatorio.',
        },
      },
    },
    dashboard: {
      title: 'Panel',
      noPermissions: {
        title: 'Sin permisos asignados',
        description:
          'Tu cuenta de administrador no tiene permisos asignados. Por favor, contacta a un administrador para solicitar acceso.',
      },
    },
    organizations: {
      title: 'Organización | Organizaciones',
      listing: 'Lista de organizaciones',
      new: 'Nueva organización',
      edit: 'Editar organización',
      delete: 'Eliminar organización',
      name: 'Nombre',
      subdomain: 'Subdominio de carreras',
      website: 'Sitio web',
      websiteHint: 'La URL del sitio web de la organización (ej. "https://ejemplo.com").',
      language: 'Idioma',
      selectLanguage: 'Seleccionar idioma',
      languageHint: 'Selecciona el idioma predeterminado para la organización.',
      dateFormat: 'Formato de fecha',
      selectDateFormat: 'Seleccionar formato de fecha',
      dateFormatHint: 'Selecciona el formato de fecha para la organización.',
      timeFormat: 'Formato de hora',
      selectTimeFormat: 'Seleccionar formato de hora',
      timeFormat12h: '12 horas (AM/PM)',
      timeFormat24h: '24 horas',
      timeFormatHint: 'Selecciona el formato de hora para la organización.',
      enabled: 'Habilitado',
      notes: 'Notas',
      selectModules: 'Seleccionar módulos',
      created: 'Creado',
      createdAt: 'Creado en',
      updatedAt: 'Actualizado en',
      nameHint: 'Este es el nombre de la organización en el sistema.',
      subdomainHint:
        'Este es el subdominio donde se alojará la página de carreras de la organización. (ej. "acme.careers.atlasthq.com")',
      enabledHint: 'Esto determina si la organización está habilitada o no.',
      deleteOrg: 'Eliminar Organización',
      deleteOrgWarning:
        'Esta operación es irreversible. Eliminará la Organización y todos los permisos asociados a esta organización.',
      deleteConfirmationInput: 'Ingrese el nombre de la organización a eliminar ({deleteOrgName}):',
      deletedSuccessfully: '¡Organización eliminada con éxito!',
      noOrganizations: 'No se encontraron organizaciones.',
      createFirst: 'Crea tu primera organización para empezar.',
      plan: 'Plan de Suscripción',
      selectPlan: 'Seleccionar un plan',
      planHint: 'Elige el plan de suscripción para esta organización',
      customPricing: 'Precio personalizado',
      contact: {
        title: 'Contacto principal',
        description: 'El contacto de incorporación para esta organización.',
        givenName: 'Nombre',
        familyName: 'Apellidos',
        nameSyncHint:
          'Cambiar el nombre también actualiza el perfil de plataforma del usuario vinculado (su cuenta de acceso); no es solo una etiqueta de esta tarjeta.',
        email: 'Correo electrónico',
        role: 'Cargo',
        phone: 'Teléfono',
        name: 'Nombre',
        noContact: 'Aún no se ha definido un contacto principal.',
        edit: 'Editar contacto',
        save: 'Guardar contacto',
        cancel: 'Cancelar',
        saving: 'Guardando...',
        saveSuccess: 'Contacto principal guardado',
        saveError: 'No se pudo guardar el contacto principal.',
        loadError: 'No se pudo cargar el contacto principal.',
        updateSuccess: 'Contacto actualizado',
        updateError: 'No se pudo actualizar el contacto.',
        resendWelcome: 'Reenviar invitación',
        resending: 'Enviando...',
        alreadySignedIn: 'Este contacto ya ha iniciado sesión',
        resendSuccess: 'Correo de bienvenida enviado a {email}',
        resendError: 'No se pudo enviar el correo de bienvenida.',
        reassign: 'Reasignar contacto principal',
        inviteStatusLabel: 'Estado de la invitación',
        invitePending: 'Aún no invitado',
        invited: 'Invitado el {date}',
        inviteFailed: 'La invitación falló: {error}',
        signedIn: 'Inició sesión el {date}',
        signedInNoDate: 'Inició sesión',
        reassignDialog: {
          title: 'Reasignar contacto principal',
          description:
            'Selecciona un usuario para convertirlo en el contacto principal de {orgName}.',
          noUsers: 'No hay otros usuarios para asignar como contacto principal.',
          makePrimary: 'Hacer principal',
          assigning: 'Asignando...',
          cancel: 'Cancelar',
          success: 'Contacto principal reasignado',
          error: 'No se pudo reasignar el contacto principal.',
          notInOrg: 'Ese usuario no es miembro de esta organización.',
        },
      },
      onboarding: {
        sendEmails: 'Enviar correos de incorporación',
        sendEmailsHint:
          'Envía el correo de bienvenida y los correos del ciclo de onboarding al contacto principal al crear la organización. El correo con la contraseña temporal se envía siempre, independientemente de esta opción.',
        personalizeWelcome: 'Personalizar correos de bienvenida',
        personalizedWelcome: 'Correos de bienvenida personalizados',
        welcomeDialog: {
          title: 'Personalizar correos de bienvenida',
          description:
            'Previsualiza y personaliza los correos de incorporación enviados al contacto principal.',
          empty: 'No hay correos de incorporación personalizables disponibles.',
          subject: 'Asunto',
          body: 'Contenido',
          preview: 'Vista previa',
          staleHint:
            'Mostrando la última vista previa válida: no se pudo renderizar el borrador actual.',
          restoreOriginal: 'Restaurar original',
          save: 'Guardar',
        },
      },
      error: {
        organizationNameRequired: 'El nombre de la organización es obligatorio',
        organizationHasDependencies: 'La organización tiene dependencias y no se puede eliminar',
        organizationNameMinLength:
          'El nombre de la organización debe tener al menos {min} caracteres',
        organizationNameMaxLength:
          'El nombre de la organización debe tener como máximo {max} caracteres',
        invalidLanguage: 'Idioma no soportado',
        invalidDateFormat: 'Formato de fecha no soportado',
        invalidTimeFormat: 'Formato de hora no soportado',
        planRequired: 'Por favor selecciona un plan',
        invalidWebsiteUrl: 'Por favor ingresa una URL válida',
        contactGivenNameRequired: 'El nombre es obligatorio',
        contactGivenNameMaxLength: 'El nombre debe tener como máximo {max} caracteres',
        contactFamilyNameRequired: 'Los apellidos son obligatorios',
        contactFamilyNameMaxLength: 'Los apellidos deben tener como máximo {max} caracteres',
        contactEmailRequired: 'El correo electrónico es obligatorio',
        contactEmailInvalid: 'Por favor ingresa un correo electrónico válido',
        contactEmailMaxLength: 'El correo electrónico debe tener como máximo {max} caracteres',
        contactRoleMaxLength: 'El cargo debe tener como máximo {max} caracteres',
        contactPhoneMaxLength: 'El teléfono debe tener como máximo {max} caracteres',
      },
      impersonate: {
        button: 'Suplantar',
        dialogTitle: 'Suplantar Organización',
        dialogDescription: 'Selecciona un usuario para abrir el portal como para {orgName}.',
        auditWarning:
          'Esta acción queda registrada en el registro de auditoría por motivos de seguridad.',
        email: 'Correo electrónico',
        name: 'Nombre',
        open: 'Abrir',
        opening: 'Abriendo...',
        cancel: 'Cancelar',
        noUsers: 'Esta organización no tiene usuarios para suplantar.',
        success: 'Portal abierto como {email}',
        popupBlocked: 'El popup fue bloqueado. Por favor permite los popups para este sitio.',
        error: 'Error al iniciar la sesión de suplantación.',
        permissionDenied: 'No tienes permiso para suplantar usuarios.',
      },
      outreachOverride: {
        title: 'Destinatario de redirección de contacto',
        help: 'Cuando se establece, todo el contacto de LinkedIn de esta organización se redirige a este perfil. Se usa para pruebas en producción.',
        placeholder: 'ej. john-doe-qa',
        save: 'Guardar',
        clear: 'Limpiar',
        notSet: 'No establecido',
        saved: 'Redirección de contacto actualizada',
        cleared: 'Redirección de contacto eliminada',
        error: 'Error al actualizar la redirección de contacto',
        confirmTitle: '¿Redirigir todo el contacto de LinkedIn?',
        confirmDescription:
          'Todos los mensajes de contacto de LinkedIn enviados por esta organización se redirigirán a "{recipient}" en lugar del candidato previsto. Los candidatos reales no recibirán ningún mensaje hasta que se elimine la redirección. ¿Seguro que deseas continuar?',
        confirmAction: 'Sí, redirigir el contacto',
      },
      permissions: {
        organizations_create: 'Crear Organizaciones',
        organizations_read: 'Ver Organizaciones',
        organizations_update: 'Actualizar Organizaciones',
        organizations_delete: 'Eliminar Organizaciones',
      },
    },
    users: {
      title: 'Usuario | Usuarios',
      listing: 'Lista de usuarios',
      new: 'Nuevo usuario',
      edit: 'Editar usuario',
      newTitle: '@:modules.users.new para {organization}',
      name: 'Nombre',
      surname: 'Apellido',
      email: 'Correo electrónico',
      created: 'Creado',
      orgId: 'ID de la organización',
      selectGroups: 'Seleccionar Grupos',
      enabled: 'Habilitado',
      status: 'Estado',
      createdAt: 'Creado en',
      updatedAt: 'Actualizado en',
      emailHint: 'Este es el correo electrónico del usuario en el sistema.',
      deleteUser: 'Eliminar Usuario',
      deleteUserWarning:
        'Esta operación es irreversible. Eliminará el Usuario y todos los permisos asociados a este usuario.',
      deleteConfirmationInput:
        'Ingrese el correo electrónico del usuario a eliminar ({deleteUserEmail}):',
      deletedSuccessfully: '¡Usuario eliminado con éxito!',
      primaryContactCannotDelete: 'Contacto principal — reasigna antes de eliminar',
      noUsers: 'No se encontraron usuarios.',
      createFirst: 'Crea tu primer usuario para empezar.',
      userStatus: {
        UNCONFIRMED: 'El usuario ha sido creado pero no confirmado',
        CONFIRMED: 'El usuario ha sido confirmado',
        EXTERNAL_PROVIDER: 'El usuario inició sesión con un IdP de terceros.',
        RESET_REQUIRED:
          'El usuario ha sido confirmado, pero debe solicitar un código y restablecer su contraseña antes de poder iniciar sesión.',
        FORCE_CHANGE_PASSWORD:
          'El usuario ha sido confirmado y puede iniciar sesión con una contraseña temporal, pero en el primer inicio de sesión, debe cambiar su contraseña a un nuevo valor antes de hacer cualquier otra cosa.',
      },
      error: {
        emailRequired: 'El correo electrónico es obligatorio',
        emailInvalid: 'El correo electrónico no es válido',
      },
      permissions: {
        users_create: 'Crear Usuarios',
        users_read: 'Ver Usuarios',
        users_update: 'Actualizar Usuarios',
        users_delete: 'Eliminar Usuarios',
      },
    },
    candidates: {
      title: 'Candidatos',
      permissions: {
        candidates_create: 'Crear Candidatos',
        candidates_read: 'Ver Candidatos',
        candidates_update: 'Actualizar Candidatos',
        candidates_delete: 'Eliminar Candidatos',
      },
    },
    ai_credits: {
      title: 'Creditos IA',
      status: {
        title: 'Estado de Creditos',
        balance: 'Saldo Total',
        planBalance: 'Saldo del Plan',
        rolloverBalance: 'Saldo Acumulado',
        monthlyAllocation: 'Asignacion Mensual',
        used: 'Usados Este Periodo',
        usage: 'Uso',
        usedLabel: 'usado',
        remaining: 'restante',
        unlimitedDescription: 'Esta organizacion tiene creditos de IA ilimitados.',
      },
      ledger: {
        title: 'Historial de Transacciones',
        date: 'Fecha',
        type: 'Tipo',
        amount: 'Monto',
        balanceAfter: 'Saldo',
        planBalanceAfter: 'Saldo del Plan',
        rolloverBalanceAfter: 'Saldo Acumulado',
        description: 'Descripcion',
        noEntries: 'No se encontraron transacciones de creditos.',
        showing: 'Mostrando {start} a {end} de {total} registros',
        historicalRowTooltip: 'Anterior al modelo de dos saldos; usar solo el Saldo total.',
      },
      transactionType: {
        ALLOCATION: 'Asignacion',
        DEDUCTION: 'Deduccion',
        TOP_UP: 'Recarga',
        PURCHASE: 'Compra',
        ADJUSTMENT: 'Ajuste',
      },
      topUp: {
        title: 'Recargar',
        description: 'Agregar creditos a esta organizacion. Siempre se suma al saldo actual.',
        amount: 'Monto',
        amountPlaceholder: 'Ingresa la cantidad de creditos (min 1)',
        amountMin: 'El monto debe ser al menos 1',
        reason: 'Motivo',
        reasonPlaceholder: 'ej., Cliente solicito creditos adicionales para contratacion Q1',
        submit: 'Agregar Creditos',
        success: 'Creditos agregados exitosamente. Nuevo saldo: {balance}',
      },
      adjust: {
        title: 'Ajustar',
        description:
          'Realizar una correccion de saldo. Usa valores negativos para eliminar creditos.',
        amount: 'Monto',
        amountPlaceholder: 'Ingresa el monto (positivo o negativo)',
        amountNotZero: 'El monto no puede ser cero',
        reason: 'Motivo',
        reasonPlaceholder: 'ej., Corrigiendo deduccion duplicada por error del sistema',
        negativeWarning: 'Esto eliminara creditos de la organizacion.',
        submit: 'Ajustar Creditos',
        success: 'Creditos ajustados exitosamente. Nuevo saldo: {balance}',
      },
    },
    llm_usage: {
      title: 'Uso de LLM',
      search: {
        title: 'Búsqueda de Uso de Tokens LLM',
        filters: 'Filtros de Búsqueda',
        organizationId: 'ID de Organización',
        userId: 'ID de Usuario',
        operation: 'Operación',
        model: 'Modelo',
        provider: 'Proveedor',
        dateRange: 'Rango de Fechas',
        pickDateRange: 'Seleccionar rango de fechas',
        searchButton: 'Buscar',
        searching: 'Buscando...',
        reset: 'Reiniciar',
        results: 'Resultados ({total} en total)',
        timestamp: 'Fecha y Hora',
        inputTokens: 'Tokens de Entrada',
        outputTokens: 'Tokens de Salida',
        totalTokens: 'Tokens Totales',
        totals: 'Totales:',
        showing: 'Mostrando {start} a {end} de {total} resultados',
        noResults: 'No se encontraron resultados. Intenta ajustar los filtros de búsqueda.',
        initialMessage:
          'Ingresa los criterios de búsqueda y haz clic en "Buscar" para encontrar registros de uso de tokens LLM.',
      },
    },
    feedback: {
      title: 'Comentarios',
      tabs: {
        message: 'Comentarios de Mensajes IA',
        general: 'Comentarios Generales',
      },
      rating: {
        up: 'Me gusta',
        down: 'No me gusta',
      },
      status: {
        new: 'Nuevo',
        reviewed: 'Revisado',
        resolved: 'Resuelto',
      },
      category: {
        bug: 'Error',
        idea: 'Idea',
        general: 'General',
      },
      search: {
        filters: 'Filtros de Búsqueda',
        organizationId: 'ID de Organización',
        userId: 'ID de Usuario',
        jobId: 'ID de Vacante',
        agent: 'Agente',
        rating: 'Valoración',
        status: 'Estado',
        category: 'Categoría',
        hasComment: 'Tiene Comentario',
        commentSearch: 'Buscar en Comentarios',
        commentPlaceholder: 'Buscar en los comentarios...',
        messageSearch: 'Buscar en Mensajes',
        messagePlaceholder: 'Buscar en los mensajes...',
        any: 'Cualquiera',
        dateRange: 'Rango de Fechas',
        pickDateRange: 'Seleccionar rango de fechas',
        searchButton: 'Buscar',
        searching: 'Buscando...',
        reset: 'Reiniciar',
        results: 'Resultados ({total} en total)',
        timestamp: 'Fecha y Hora',
        submitter: 'Remitente',
        organization: 'Organización',
        comment: 'Comentario',
        showing: 'Mostrando {start} a {end} de {total} resultados',
        noResults: 'No se encontraron resultados. Intenta ajustar los filtros de búsqueda.',
        initialMessage:
          'Ingresa los criterios de búsqueda y haz clic en "Buscar" para encontrar comentarios.',
      },
      general: {
        message: 'Mensaje',
        status: 'Estado',
        adminNotes: 'Notas del Administrador',
      },
      triage: {
        title: 'Gestionar Comentario',
        description: 'Actualiza el estado y agrega notas internas para este comentario.',
        notesPlaceholder: 'Notas internas (no visibles para el usuario)...',
        saving: 'Guardando...',
      },
      delete: {
        button: 'Eliminar comentario',
        title: '¿Eliminar este comentario?',
        description:
          'Esto elimina el comentario de forma permanente. Esta acción no se puede deshacer.',
        confirm: 'Eliminar',
        success: 'Comentario eliminado',
      },
      detail: {
        title: 'Comentario de Mensaje',
        clientContext: 'Contexto del Cliente',
        session: 'Contexto de la Sesión',
        status: 'Estado',
        ratedMessage: 'Mensaje valorado',
        messageNotLocated: 'No se pudo localizar el mensaje valorado en esta conversación.',
        sessionUnavailable: 'La sesión de este comentario ya no está disponible.',
      },
    },
    offers: {
      title: 'Ofertas',
      permissions: {
        offers_create: 'Crear Ofertas',
        offers_read: 'Ver Ofertas',
        offers_update: 'Actualizar Ofertas',
        offers_delete: 'Eliminar Ofertas',
      },
    },
    templates: {
      title: 'Plantillas',
      permissions: {
        templates_update: 'Actualizar Plantillas',
      },
    },
    sourcing: {
      title: 'Búsqueda de prospectos',
      permissions: {
        sourcing_read: 'Ver prospectos encontrados',
        sourcing_search: 'Ejecutar búsquedas de prospectos',
        sourcing_update: 'Actualizar prospectos encontrados',
      },
    },
    messaging_connections: {
      title: 'Conexiones de mensajería',
      permissions: {
        messaging_connections_create: 'Conectar cuentas de mensajería',
        messaging_connections_read: 'Ver conexiones de mensajería',
        messaging_connections_update: 'Actualizar conexiones de mensajería',
        messaging_connections_delete: 'Desconectar cuentas de mensajería',
      },
    },
    prospect_outreach: {
      title: 'Contacto con prospectos',
      permissions: {
        prospect_outreach_create: 'Enviar mensajes de contacto',
        prospect_outreach_read: 'Ver historial de contacto',
        prospect_outreach_update: 'Editar mensajes de seguimiento programados',
        prospect_outreach_delete: 'Cancelar mensajes de seguimiento programados',
      },
    },
    module: {
      title: 'Módulo | Módulos',
      name: 'Nombre',
      atlas_agent: 'Agente Atlas',
      audit_access: 'Acceso a Auditoría',
      group_management: 'Gestión de Grupos',
      interview_management: 'Gestión de Entrevistas',
      interview_settings_management: 'Configuración de Entrevistas',
      organization_settings_management: 'Configuración de Organización',
      scorecard_access: 'Acceso a Scorecards',
      user_management: 'Gestión de Usuarios',
      noModules: 'No se encontraron módulos.',
      jobs_management: 'Empleos',
      candidates_management: 'Candidatos',
      messages_management: 'Gestión de Mensajes',
      templates_management: 'Gestión de Plantillas',
      candidate_sourcing_management: 'Gestión de Búsqueda de Candidatos',
      messaging_connections_management: 'Gestión de Conexiones de Mensajería',
      prospect_outreach_management: 'Gestión de Contacto con Prospectos',
    },
    operation: {
      title: 'Operación | Operaciones',
      noOperations: 'No se encontraron operaciones.',
    },
    groups: {
      title: 'Grupo | Grupos',
      name: 'Nombre',
      manage: 'Administrar Grupos',
      selectOrganization: 'Selecciona una Organización para ver sus Grupos',
      viewTitle: 'Grupos para',
      new: 'Nuevo grupo',
      editGroup: 'Editar Grupo',
      deleteGroup: 'Eliminar Grupo',
      deleteGroupWarning:
        'Esta operación es irreversible. Se eliminará el grupo y todos los permisos asiciados a los usuarios que pertenecen a este.',
      deleteGroupDescription: 'Ingrese el nombre del grupo a eliminar ({deleteGroupName}):',
      nameHint: 'Ingrese el nombre del rol',
      noGroups: 'No hay grupos disponibles',
      permissions: {
        groups_create: 'Crear Grupos de Permisos',
        groups_read: 'Ver Grupos de Permisos',
        groups_update: 'Actualizar Grupos de Permisos',
        groups_delete: 'Eliminar Grupos de Permisos',
      },
      toast: {
        permissionsUpdated: 'Permisos actualizados',
        groupNameRequired: 'El nombre del grupo es requerido',
        groupCreated: 'Grupo creado',
        groupUpdated: 'Grupo actualizado',
        groupDeleted: 'Grupo eliminado',
      },
    },
    jobs: {
      title: 'Empleo | Empleos',
      jobTitle: 'Título',
      candidates: 'Candidatos',
      noJobs: 'No se encontraron empleos.',
      permissions: {
        jobs_create: 'Crear Empleos',
        jobs_read: 'Ver Empleos',
        jobs_update: 'Actualizar Empleos',
        jobs_delete: 'Eliminar Empleos',
      },
    },
    careersSite: {
      title: 'Sitio de Carreras',
      syncJobs: 'Sincronizar Empleos',
      syncSettings: 'Sincronizar Configuración',
      syncAll: 'Sincronizar Todo',
      syncJobsDescription: 'Sincronizar todos los empleos publicados al sitio de carreras',
      syncSettingsDescription: 'Sincronizar configuración de la organización al sitio de carreras',
      syncAllDescription: 'Sincronizar empleos y configuración al sitio de carreras',
      syncing: 'Sincronizando...',
      syncSuccess: 'Sincronización iniciada correctamente',
      syncError: 'Error al sincronizar',
    },
    subscriptions: {
      tabs: {
        details: 'Detalles',
        subscription: 'Suscripcion',
        aiCredits: 'Creditos IA',
      },
      currentPlan: 'Plan Actual',
      subscriptionDetails: 'Detalles de la suscripción de tu organización',
      changePlan: 'Cambiar Plan',
      trial: {
        title: 'Prueba',
        endsOn: 'La prueba termina el {date}',
        notStarted: 'La prueba no ha comenzado — empieza con el primer inicio de sesión del cliente',
        startedOn: 'La prueba comenzó el {date}',
        extendLabel: 'Días a añadir',
        extendButton: 'Extender prueba',
        extended: 'Prueba extendida',
        restartTitle: 'Reiniciar prueba',
        restartDescription:
          'Esta organización tiene un plan de prueba pero no está en prueba actualmente. Reinicia una prueba de {days} días y reactiva la organización.',
        restartButton: 'Reiniciar prueba',
        restarted: 'Prueba reiniciada',
      },
      selectNewPlan: 'Selecciona un nuevo plan para esta organización',
      newPlan: 'Nuevo Plan',
      planDetails: 'Detalles del Plan',
      users: 'Usuarios',
      jobDescriptions: 'Descripciones de Empleo',
      aiCreditsMonthly: 'Créditos IA / Mes',
      enabledAgents: 'Agentes IA Habilitados',
      noAgents: 'Sin agentes habilitados',
      unlimited: 'Ilimitado',
      downgradeWarning: 'Advertencia de Degradación',
      current: 'actual',
      allowed: 'permitido',
      confirmDowngrade: '¿Estás seguro de que deseas continuar?',
      confirmChange: 'Confirmar Cambio',
      planChanged: 'Plan cambiado correctamente',
      enterValue: 'Ingresa un valor',
      overridesCleared: 'Límites personalizados eliminados correctamente',
      planLimits: {
        sectionTitle: 'Límites del Plan',
        editTitle: 'Editar límites del plan',
        editDescription:
          'Personaliza los límites del plan y los agentes habilitados para esta organización. Los cambios solo se aplican a esta organización.',
        reason: 'Motivo',
        reasonPlaceholder: 'ej., Cliente firmó contrato empresarial con términos personalizados',
        reasonHint: 'Esto se registrará para propósitos de auditoría',
        customized: 'Personalizado',
        vsCatalog: 'vs plan: {value}',
        onVersionN: 'En v{current}; la última es v{latest}',
        footgunWarning:
          'Estas personalizaciones se restablecerán si más adelante se aplica una nueva versión del plan a los clientes existentes. El cambio queda registrado en el historial de la suscripción.',
        saved: 'Límites del plan guardados correctamente',
        resetToCatalog: 'Restablecer a los valores del plan',
        resetConfirmTitle: 'Restablecer a los valores del plan',
        resetConfirmBody:
          'Esto descartará todos los límites personalizados y volverá a los valores actuales del plan para esta organización.',
        atLeastOneFieldRequired: 'Cambia al menos un campo para guardar.',
      },
      history: {
        title: 'Historial de Suscripción',
        description: 'Línea de tiempo de cambios en la suscripción',
        noHistory: 'No hay historial de suscripción disponible',
        date: 'Fecha',
        event: 'Evento',
        details: 'Detalles',
        notes: 'Notas',
        changedByColumn: 'Modificado Por',
        eventType: {
          CREATED: 'Suscripción Creada',
          PLAN_CHANGED: 'Plan Cambiado',
          CANCELLED: 'Suscripción Cancelada',
          OVERRIDE_CHANGED: 'Límites personalizados editados',
          CATALOG_VERSION_APPLIED: 'Versión del plan aplicada',
        },
        to: 'a',
        system: 'Sistema',
      },
    },
    plans: {
      title: 'Plan | Planes',
      description: 'Gestiona los planes que vende Atlast.',
      list: {
        includeArchived: 'Incluir planes archivados',
        empty: 'No se encontraron planes.',
        activeBadge: 'Activo',
        archivedBadge: 'Archivado',
        trialBadge: 'Prueba · {days} días',
        privateBadge: 'Privado',
      },
      card: {
        perMonth: 'mes',
        annualLine: '{price} facturado anualmente',
        annualSavings: 'ahorra un {percent}%',
        usersLine: '{count} usuarios',
        creditsLine: '{count} créditos de IA / mes',
        jobsLine: '{count} descripciones de empleo',
      },
      actions: {
        create: 'Crear plan',
        edit: 'Editar',
        saveChanges: 'Guardar cambios',
        archive: 'Archivar plan',
        pushToCustomers: 'Aplicar a clientes existentes',
        resetToCatalog: 'Restablecer a los valores del plan',
        applyThisVersion: 'Aplicar esta versión',
      },
      fields: {
        code: 'Código',
        name: 'Nombre',
        description: 'Descripción',
        monthlyPrice: 'Precio mensual',
        annualPrice: 'Precio anual',
        maxUsers: 'Usuarios máximos',
        aiCreditsMonthly: 'Créditos IA / mes',
        maxJobDescriptions: 'Máximo de descripciones de empleo',
        enabledAgents: 'Agentes IA habilitados',
        version: 'Versión',
        isActive: 'Activo',
        archivedAt: 'Archivado el',
        contactSales: 'Contactar con ventas',
        currency: 'Moneda',
        publicApiJobsEnabled: 'API pública de empleos',
        publicApiJobsEnabledHint:
          'Permite a este plan acceder a la API pública de empleos y webhooks',
        trialDurationDays: 'Duración de la prueba (días)',
        trialDurationDaysHint:
          'Si se indica, asignar este plan inicia una prueba gratuita con esta cantidad de días. Déjalo vacío para un plan sin prueba.',
        isPublic: 'Visibilidad pública',
        isPublicHint:
          'Muestra este plan en los precios públicos y en el selector de planes de la app. Desactívalo para planes internos como las pruebas.',
        enabledModules: 'Módulos habilitados',
        enabledModulesDescription:
          'Módulos con los que se aprovisiona una nueva organización self-serve al comprar este plan.',
        enabledModulesEmptyWarning:
          'Un plan de pago sin módulos seleccionados no se podrá comprar.',
        moduleNotAvailable: 'Aún no disponible',
      },
      tabs: {
        overview: 'Resumen',
        versionHistory: 'Historial de versiones',
        subscribers: 'Suscriptores',
      },
      apply: {
        previewTitle: 'Aplicar a clientes existentes',
        explanation:
          'Aplica la versión {version} de "{name}" a todos los suscriptores actuales de este plan. Cada organización afectada recibirá una instantánea nueva de esta versión — su precio, límites y agentes habilitados se reemplazarán con los valores que se muestran abajo.',
        dryRunHint:
          'A continuación ejecutarás una simulación para confirmar exactamente cuántos suscriptores se verán afectados antes de aplicar ningún cambio.',
        confirmHint:
          'Pulsa "Aplicar" para aplicar la versión {version} a {count} suscriptor(es). Esto crea nuevas instantáneas del plan por organización y registra una entrada "Versión del plan aplicada" en cada historial de suscripción.',
        previewBody:
          '{matched} organización(es) en este plan. {willMove} pasará(n) a la v{version}.',
        dryRunButton: 'Ejecutar simulación',
        confirmButton: 'Aplicar a {count} suscriptor(es)',
        matchedSubscriptions: 'Suscripciones afectadas',
        willBeMoved: 'Pasarán a la nueva versión',
        alreadyUpToDate: 'Todos los suscriptores ya están en esta versión.',
        noSubscribers: 'Este plan no tiene suscriptores.',
        success: '{count} suscriptor(es) movido(s) a la v{version}',
        archivedConflict:
          'Esta versión del plan ya no está disponible. Actualiza la página e inténtalo de nuevo.',
        footgun:
          'Esto reemplazará cualquier límite personalizado configurado mediante "Editar límites del plan" en estos suscriptores.',
      },
      archive: {
        title: 'Archivar plan',
        body: 'Los planes archivados no pueden asignarse a nuevas organizaciones. Los suscriptores existentes conservan su instantánea actual del plan.',
        confirmation: 'Escribe {code} para confirmar',
        button: 'Archivar plan',
      },
      sync: {
        menuLabel: 'Sincronizar',
        fullSync: 'Sincronización completa con Stripe',
        republishOnly: 'Solo volver a publicar plans.json',
        confirm: {
          title: '¿Sincronización completa con Stripe?',
          body: 'Esto envía todos los planes activos con precio a Stripe (productos y precios) y después vuelve a publicar plans.json en el CDN. Los cambios en Stripe son idempotentes. ¿Continuar?',
          button: 'Sincronizar con Stripe',
        },
        success:
          'Se sincronizaron {synced} plan(es), se omitieron {skipped}. plans.json se volvió a publicar.',
        republishSuccess: 'plans.json se volvió a publicar en el CDN.',
        result: {
          title: 'La sincronización finalizó con incidencias',
          summary: 'Se sincronizaron {synced} plan(es), se omitieron {skipped}.',
          planErrorsTitle: 'Planes que no se pudieron sincronizar con Stripe',
          planErrorRow: '{code} v{version}: {message}',
          publishFailed: 'Error al volver a publicar plans.json: {error}',
          publishOk: 'plans.json se volvió a publicar correctamente.',
          close: 'Cerrar',
        },
      },
      error: {
        codeAlreadyExists: 'Ya existe un plan con este código.',
        unknownCode: 'Plan no encontrado.',
        atLeastOneFieldRequired: 'Cambia al menos un campo para guardar.',
        invalidSlug:
          'El código debe comenzar con una letra minúscula y solo puede contener letras minúsculas, dígitos, guiones bajos o guiones (2-41 caracteres).',
        concurrentEdit:
          'Otro administrador acaba de editar este plan. Actualiza e inténtalo de nuevo.',
        codeRequired: 'El código es obligatorio.',
        nameRequired: 'El nombre es obligatorio.',
        invalidPrice: 'El precio debe ser un entero no negativo o estar vacío.',
        invalidLimit: 'El límite debe ser -1 (ilimitado) o un entero no negativo.',
        invalidAgent: 'Uno o varios agentes seleccionados no son válidos.',
        invalidTrialDuration:
          'La duración de la prueba debe ser un número entero positivo de días, o estar vacía.',
      },
    },
    organization_settings: {
      title: 'Configuración de la Compañía',
      permissions: {
        organization_settings_create: 'Crear Configuración de la Compañía',
        organization_settings_read: 'Ver Configuración de la Compañía',
        organization_settings_update: 'Actualizar Configuración de la Compañía',
        organization_settings_delete: 'Eliminar Configuración de la Compañía',
      },
    },
    audit: {
      title: 'Registros de Auditoría',
      permissions: {
        audit_read: 'Ver Registros de Auditoría',
      },
    },
    interview: {
      title: 'Entrevistas',
      permissions: {
        interview_create: 'Crear Entrevistas',
        interview_delete: 'Eliminar Entrevistas',
        interview_read: 'Ver Entrevistas',
        interview_update: 'Actualizar Entrevistas',
      },
    },
    interview_settings: {
      title: 'Configuración de Entrevistas',
      permissions: {
        interview_settings_create: 'Crear Configuración de Entrevistas',
        interview_settings_delete: 'Eliminar Configuración de Entrevistas',
        interview_settings_read: 'Ver Configuración de Entrevistas',
        interview_settings_update: 'Actualizar Configuración de Entrevistas',
      },
    },
    scorecard: {
      title: 'Scorecards',
      permissions: {
        scorecard_create: 'Crear Scorecards',
        scorecard_delete: 'Eliminar Scorecards',
        scorecard_read: 'Ver Scorecards',
        scorecard_update: 'Actualizar Scorecards',
      },
    },
    help: {
      title: 'Ayuda',
      userStatus: 'Estados del Usuario',
      userStatusDescription: 'El estado del usuario puede ser uno de los siguientes',
    },
    dev: {
      title: 'Rincón Dev',
    },
    billing: {
      title: 'Facturación',
      creditPricing: {
        title: 'Precios de recarga de créditos',
        navTitle: 'Precios de recarga de créditos',
        description:
          'Define los límites de compra y la tarifa fija por crédito de cada banda de volumen. Los cambios se aplican a las nuevas cotizaciones de inmediato.',
        empty: 'Aún no hay configuración de precios.',
        saveSuccess: 'Precios actualizados',
        saveError: 'No se pudieron guardar los precios',
      },
      bounds: {
        title: 'Límites de compra',
        currencyReadOnly: 'Moneda: {currency} · solo lectura',
        stepHint:
          'El paso solo afecta el ajuste del control deslizante del comprador; cualquier cantidad dentro del rango se cotiza igualmente.',
      },
      fields: {
        minCredits: 'Créditos mínimos',
        maxCredits: 'Créditos máximos',
        step: 'Paso del deslizador',
      },
      tiers: {
        title: 'Bandas de precios',
        hint: 'Las bandas son contiguas: cada banda empieza donde termina la anterior. La última banda es ilimitada.',
        add: 'Añadir banda',
        remove: 'Eliminar banda',
        tierLabel: 'Banda {n}',
        unbounded: 'Ilimitado',
        columns: {
          tier: 'Banda',
          from: 'Desde',
          to: 'Hasta',
          price: 'Precio / crédito (céntimos)',
          popular: 'Popular',
        },
      },
      actions: {
        save: 'Guardar cambios',
      },
      error: {
        minCreditsInvalid: 'Introduce un número entero positivo.',
        maxCreditsInvalid: 'Introduce un número entero positivo.',
        stepInvalid: 'Introduce un número entero positivo.',
        minMaxOrder: 'El mínimo debe ser menor o igual que el máximo.',
        tierPriceInvalid: 'Introduce un precio de al menos 1 céntimo.',
        tierMaxInvalid: 'Introduce un número entero positivo.',
        tierMaxAscending: 'Debe ser mayor que {from}.',
        tiersRequired: 'Añade al menos una banda.',
        lastTierUnbounded: 'La banda superior debe ser ilimitada.',
        onePopularMax: 'Solo una banda puede marcarse como más popular.',
        overflow:
          'Estos valores podrían superar el cargo máximo. Reduce los créditos máximos o el precio.',
      },
    },
    technical: {
      title: 'Técnico',
    },
    maintenance: {
      title: 'Mantenimiento del Sistema',
      workflowSnapshots: {
        title: 'Limpieza de Snapshots de Workflows',
        description:
          'Ejecutar manualmente la limpieza de snapshots expirados de workflows de Mastra (mayores a 24 horas). Esto se ejecuta automáticamente a medianoche.',
        button: 'Limpiar Snapshots',
        cleaning: 'Limpiando...',
        success: 'Se limpiaron {count} snapshots de workflows expirados',
      },
      reconcileConnections: {
        title: 'Reconciliar Conexiones de LinkedIn',
        description:
          'Verificar todas las conexiones de LinkedIn (UniPile) contra el proveedor y marcar como desconectadas aquellas cuya cuenta ya no existe. Esto se ejecuta automáticamente a diario y al enviar; use esto para reconciliar ahora.',
        button: 'Reconciliar Ahora',
        reconciling: 'Reconciliando...',
        success: 'Se verificaron {checked} conexiones, {disconnected} desconectadas',
      },
    },
    admin_users: {
      title: 'Usuario Admin | Usuarios Admin',
      listing: 'Lista de Usuarios Admin',
      editPermissions: 'Editar Permisos',
      name: 'Nombre',
      email: 'Correo electrónico',
      operationsCount: 'Permisos',
      noAdminUsers: 'No se encontraron usuarios admin.',
      permissions: {
        title: 'Permisos',
        description: 'Selecciona los permisos para este usuario admin',
        module: 'Módulo',
        actions: 'Acciones',
        selectAll: 'Seleccionar Todo',
        deselectAll: 'Deseleccionar Todo',
        noChanges: 'No hay cambios para guardar',
        saveSuccess: 'Permisos guardados con éxito',
        saveError: 'Error al guardar los permisos',
        save: 'Guardar Permisos',
        saving: 'Guardando...',
      },
      modules: {
        orgs: 'Organizaciones',
        users: 'Usuarios',
        subs: 'Suscripciones',
        plan_catalog: 'Planes',
        billing: 'Facturación',
        features: 'Funcionalidades',
        org_access: 'Acceso a Organizaciones',
        permission_template: 'Plantillas de Permisos',
        jobs: 'Empleos',
        careers: 'Carreras',
        ai: 'IA',
        redis: 'Redis',
        admin_users: 'Usuarios Admin',
        feedback: 'Comentarios',
        system: 'Sistema',
      },
      actions: {
        create: 'Crear',
        read: 'Leer',
        update: 'Actualizar',
        delete: 'Eliminar',
        impersonate: 'Suplantar',
      },
      deleteAdminUser: {
        title: 'Eliminar Administrador',
        warning:
          'Esto eliminará permanentemente al administrador y revocará su sesión activa. Esta acción no se puede deshacer.',
        confirmationInput: 'Escribe el correo "{email}" para confirmar la eliminación:',
        success: 'Administrador eliminado correctamente',
        errors: {
          notFound: 'Administrador no encontrado. La lista ha sido actualizada.',
          forbidden: 'No tienes permiso para eliminar administradores.',
          cannotDeleteSelf: 'No puedes eliminar tu propia cuenta.',
          generic: 'Error al eliminar al administrador',
        },
      },
    },
    permission_templates: {
      title: 'Plantilla de Permisos | Plantillas de Permisos',
      listing: 'Plantillas de Permisos',
      showInactive: 'Mostrar inactivas',
      active: 'Activa',
      inactive: 'Inactiva',
      noTemplates: 'No se encontraron plantillas de permisos.',
      adminFreeze: {
        title: '¿Vas a añadir una nueva operación del sistema?',
        body: 'La plantilla Admin es una instantánea fija de operaciones: no crece automáticamente. Cuando añadas una nueva operación a la plataforma, agrégala a la plantilla Admin con "Editar operaciones" y luego pulsa "Notificar" para que las organizaciones vinculadas la reciban.',
      },
      actions: {
        create: 'Nueva Plantilla',
        compare: 'Comparar',
        backToList: 'Volver al listado',
        editDetails: 'Editar detalles',
        saveDetails: 'Guardar detalles',
        editOperations: 'Editar operaciones',
        saveOperations: 'Guardar operaciones',
      },
      compare: {
        title: 'Comparar Plantillas',
        subtitle: 'Ve de un vistazo qué operaciones concede cada plantilla.',
        operationsColumn: 'Operaciones',
        searchPlaceholder: 'Buscar operaciones…',
        noTemplates: 'No hay plantillas para comparar.',
        noOperations: 'Ninguna operación coincide con tu búsqueda.',
        granted: 'Concedida',
        notGranted: 'No concedida',
      },
      sections: {
        details: 'Detalles',
        detailsHint:
          'Nombre, descripción, indicador de predeterminada y orden. Editar esto NO cambia la versión.',
        operations: 'Operaciones',
        operationsCreateHint:
          'Selecciona las operaciones que concede esta plantilla. La plantilla comienza en la versión 1.',
        operationsEditHint:
          'Reemplazar el conjunto de operaciones incrementa la versión si el conjunto realmente cambió.',
      },
      fields: {
        name: 'Nombre',
        description: 'Descripción',
        version: 'Versión',
        isDefault: 'Predeterminada',
        isDefaultHint:
          'Las plantillas predeterminadas se aprovisionan automáticamente a las NUEVAS organizaciones cuando se registran.',
        isDefaultWarningTitle: 'Solo afecta a nuevas organizaciones',
        isDefaultWarning:
          'Marcar esta plantilla como predeterminada la aprovisiona a las organizaciones creadas a partir de ahora. Las organizaciones existentes no la reciben retroactivamente.',
        sortOrder: 'Orden',
        sortOrderHint: 'Los números más bajos se aprovisionan primero.',
        operationCount: 'Operaciones',
        linkedGroupCount: 'Grupos vinculados',
        status: 'Estado',
      },
      operations: {
        searchPlaceholder: 'Buscar operaciones…',
        selectedCount: '{count} seleccionadas',
        selectAll: 'Seleccionar todo',
        deselectAll: 'Deseleccionar todo',
        noOperations: 'No hay operaciones para mostrar.',
        versionWarningTitle: 'Este cambio puede incrementar la versión',
        versionWarning:
          'Guardar un conjunto de operaciones distinto incrementa la versión de la plantilla. Las organizaciones vinculadas verán entonces una actualización disponible (notifícalas por separado).',
        versionBumped: 'Operaciones guardadas: la plantilla ahora es la versión {version}.',
        noVersionChange:
          'Operaciones guardadas: el conjunto no cambió, por lo que la versión se mantuvo igual.',
      },
      notify: {
        title: 'Notificar a las organizaciones vinculadas',
        description:
          'Envía una notificación en la app a las organizaciones cuyos grupos vinculados están por detrás de la versión actual. Es un paso manual y deliberado: editar una plantilla nunca notifica automáticamente.',
        action: 'Notificar a orgs vinculadas',
        inactiveHint:
          'Las plantillas inactivas no pueden enviar notificaciones. Reactiva la plantilla primero.',
        inactiveError: 'No se puede notificar: esta plantilla está inactiva.',
        resultTitle: 'Resultado de la última notificación',
        resultCounts: 'Se notificó a {orgs} organización(es), {users} usuario(s).',
        idempotencyNote:
          'Volver a pulsar es seguro: las orgs ya notificadas para esta versión no reciben nada.',
      },
      disable: {
        action: 'Desactivar',
        title: 'Desactivar plantilla',
        calloutTitle: 'Los grupos vinculados siguen funcionando',
        calloutBody:
          'Desactivar oculta esta plantilla de nuevas aplicaciones y creaciones. Los {count} grupo(s) ya vinculados siguen funcionando y conservan su vínculo.',
        description: '¿Seguro que quieres desactivar "{name}"?',
        confirm: 'Desactivar',
        success: 'Plantilla desactivada.',
      },
      enable: {
        action: 'Activar',
        title: 'Activar plantilla',
        description:
          '¿Reactivar "{name}" para que pueda aplicarse y usarse para crear nuevos grupos de nuevo?',
        confirm: 'Activar',
        success: 'Plantilla activada.',
      },
      error: {
        nameRequired: 'El nombre es obligatorio.',
        sortOrderInvalid: 'El orden debe ser un número entero no negativo.',
        nameExists: 'Ya existe una plantilla con este nombre.',
        operationsRequired: 'Selecciona al menos una operación.',
        invalidOperations: 'Una o más operaciones seleccionadas no son válidas.',
      },
    },
    redis: {
      title: 'Redis y Colas',
      refresh: 'Actualizar',
      connectionStatus: 'Estado de Conexión',
      connected: 'Conectado',
      disconnected: 'Desconectado',
      aggregatedStats: 'Estadísticas Agregadas',
      queues: 'Colas',
      paused: 'Pausado',
      failedJobs: 'Trabajos Fallidos',
      noFailedJobs: 'No hay trabajos fallidos en esta cola.',
      totalFailedJobs: '{count} trabajo(s) fallido(s)',
      retryAll: 'Reintentar Todos',
      retry: 'Reintentar',
      deleteAll: 'Eliminar Todos',
      lastUpdated: 'Última actualización',
      jobId: 'ID del Trabajo',
      jobName: 'Nombre del Trabajo',
      failedReason: 'Razón del Fallo',
      attempts: 'Intentos',
      viewDetails: 'Ver Detalles',
      jobDetails: 'Detalles del Trabajo',
      jobDetailsDescription: 'Información completa sobre este trabajo',
      state: 'Estado',
      createdAt: 'Creado',
      processedOn: 'Procesado',
      finishedOn: 'Finalizado',
      stacktrace: 'Traza de Error',
      jobData: 'Datos del Trabajo',
      deleteJob: 'Eliminar Trabajo',
      confirmDeleteTitle: 'Eliminar Trabajo Fallido',
      confirmDeleteDescription:
        '¿Estás seguro de que deseas eliminar el trabajo {jobId}? Esta acción no se puede deshacer.',
      confirmDeleteAllTitle: 'Eliminar Todos los Trabajos Fallidos',
      confirmDeleteAllDescription:
        '¿Estás seguro de que deseas eliminar los {count} trabajo(s) fallido(s) de la cola {queue}? Esta acción no se puede deshacer.',
      stats: {
        waiting: 'Esperando',
        active: 'Activos',
        completed: 'Completados',
        failed: 'Fallidos',
        delayed: 'Retrasados',
      },
      health: {
        healthy: 'Saludable',
        warning: 'Advertencia',
        critical: 'Crítico',
      },
      // Tabs
      tabs: {
        queues: 'Colas',
        keys: 'Claves',
        repeatableJobs: 'Trabajos Programados',
      },
      // Pause/Resume
      pause: 'Pausar',
      resume: 'Reanudar',
      confirmPauseTitle: 'Pausar Procesamiento de Cola',
      confirmPauseDescription:
        '¿Estás seguro de que deseas pausar la cola {queue}? Los trabajos activos se completarán, pero no se procesarán nuevos trabajos hasta que se reanude.',
      queuePaused: 'La cola {queue} ha sido pausada',
      queueResumed: 'La cola {queue} ha sido reanudada',
      // Repeatable Jobs
      repeatableJobs: 'Trabajos Programados',
      noRepeatableJobs: 'No se encontraron trabajos programados.',
      repeatableJobName: 'Nombre del Trabajo',
      repeatableJobPattern: 'Patrón',
      repeatableJobNextRun: 'Próxima Ejecución',
      confirmRemoveRepeatableTitle: 'Eliminar Trabajo Programado',
      confirmRemoveRepeatableDescription:
        '¿Estás seguro de que deseas eliminar el trabajo programado "{jobName}" de la cola {queue}? Esto detendrá su ejecución automática.',
      repeatableJobRemoved: 'Trabajo programado eliminado con éxito',
      allQueues: 'Todas las Colas',
      filterByQueue: 'Filtrar por cola',
      // Key Browser
      keyBrowser: 'Explorador de Claves',
      searchPattern: 'Patrón',
      searchPatternPlaceholder: 'ej., cv-eval-*, candidate-otp-*',
      search: 'Buscar',
      noKeysFound: 'No se encontraron claves que coincidan con el patrón.',
      keyName: 'Clave',
      keyType: 'Tipo',
      keyTtl: 'TTL',
      keyValue: 'Valor',
      keyEncoding: 'Codificación',
      loadMore: 'Cargar Más',
      viewKey: 'Ver Detalles de Clave',
      confirmDeleteKeyTitle: 'Eliminar Clave de Redis',
      confirmDeleteKeyDescription:
        '¿Estás seguro de que deseas eliminar la clave "{key}"? Esta acción no se puede deshacer.',
      keyDeleted: 'Clave eliminada con éxito',
      ttlNoExpiry: 'Sin expiración',
      enterSearchPattern: 'Ingresa un patrón para buscar claves de Redis',
      keyDetails: 'Detalles de Clave',
      keyDetailsDescription: 'Ver el contenido y metadatos de esta clave de Redis',
    },
    messages: {
      title: 'Mensajes',
      permissions: {
        messages_create: 'Crear Mensajes',
        messages_read: 'Ver Mensajes',
        messages_update: 'Actualizar Mensajes',
        messages_delete: 'Eliminar Mensajes',
      },
    },
  },
  common: {
    language: 'Idioma',
    dark: 'Oscuro',
    light: 'Claro',
    auto: 'Automático',
    loading: 'Cargando...',
    tryAgain: 'Inténtalo de nuevo',
    yes: 'Sí',
    no: 'No',
    total: 'Total',
    enabled: 'Habilitado',
    disabled: 'Deshabilitado',
    showId: 'Mostrar {id}',
    copy: 'Copiar',
    save: 'Guardar',
    cancel: 'Cancelar',
    messages: {
      loading: 'Cargando...',
      noResults: 'No se encontraron resultados.',
      createdSuccessfully: '¡{item} creado con éxito!',
      updatedSuccessfully: '¡{item} actualizado con éxito!',
    },
    actions: {
      title: 'Acciones',
      warning: 'Advertencia',
      create: 'Crear',
      cancel: 'Cancelar',
      update: 'Actualizar',
      view: 'Ver',
      edit: 'Editar',
      delete: 'Eliminar',
      deleting: 'Eliminando...',
      back: 'Volver',
    },
  },
  users: {
    errors: {
      user_is_primary_contact:
        'Este usuario es el contacto principal de la organización. Reasigna el contacto principal antes de eliminarlo.',
    },
  },
  organizations: {
    errors: {
      invalid_subdomain_format:
        'El subdominio debe contener solo caracteres alfanuméricos en minúsculas y guiones, entre 3 y 63 caracteres',
      reserved_subdomain:
        'Este subdominio está reservado y no se puede utilizar. Por favor, elija un subdominio diferente.',
      modules_required: 'Se debe asignar al menos un módulo al crear una organización',
      subdomain_already_exists: "Ya existe una organización con el subdominio '{subdomain}'",
      name_already_exists: "Ya existe una organización con el nombre '{name}'",
      conflict:
        'No se pudo crear la organización debido a un conflicto. Por favor, inténtelo de nuevo.',
    },
  },
  error: {
    error: 'Error',
    failedToFetch: 'No se pudieron obtener los datos. Por favor, inténtalo de nuevo más tarde.',
    message: 'Ocurrió un error. Por favor, inténtalo de nuevo más tarde.',
  },
  versionUpdate: {
    title: 'Nueva versión disponible',
    message: 'Actualiza ahora, o lo haremos automáticamente en tu próxima navegación.',
    refreshNow: 'Actualizar',
    updatedTitle: 'Actualizado a v{version}',
    updatedMessage: 'Ya estás en la última versión.',
  },
}
